/** Aviso de Privacidad Integral conforme a la
 *  Ley Federal de Protección de Datos Personales en Posesión de los Particulares
 *  (LFPDPPP, Diario Oficial 5 de julio de 2010) y su Reglamento.
 *  Última actualización: a la fecha del primer despliegue del sitio.
 */
export default function Privacidad() {
  const lastUpdated = "Mayo de 2026";
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-8 py-12" data-testid="privacy-page">
      <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-rojo">
        Documento legal
      </p>
      <h1 className="font-serif-display text-4xl sm:text-5xl mt-2 leading-tight">
        Aviso de Privacidad
      </h1>
      <p className="font-mono text-[11px] uppercase tracking-widest text-sub mt-2">
        Última actualización: {lastUpdated}
      </p>

      <div className="prose prose-stone mt-8 max-w-none font-sans text-[16px] leading-relaxed text-ink">
        <p>
          En cumplimiento con lo dispuesto por la <strong>Ley Federal de Protección de Datos Personales
          en Posesión de los Particulares</strong> (LFPDPPP), su Reglamento, y los Lineamientos del Aviso
          de Privacidad publicados por el INAI, ponemos a su disposición el siguiente Aviso de Privacidad.
        </p>

        <h2 className="font-serif-display text-2xl mt-8 mb-2">1. Identidad del responsable</h2>
        <p>
          <strong>POLÍTICA REAL</strong> (en adelante, "el Responsable"), proyecto editorial independiente
          con domicilio en la Ciudad de México, México, es responsable del uso y protección de sus datos
          personales recabados a través del sitio web <code>politicareal.com</code> y sus subdominios.
          Para cualquier asunto relacionado con este Aviso, puede contactarnos al correo electrónico:
          {" "}<a className="underline" href="mailto:privacidad@politicareal.com">privacidad@politicareal.com</a>.
        </p>

        <h2 className="font-serif-display text-2xl mt-8 mb-2">2. Datos personales que se recaban</h2>
        <p>
          El Responsable recaba los siguientes datos personales cuando usted utiliza el sitio:
        </p>
        <ul className="list-disc pl-6 my-3 space-y-1">
          <li><strong>Datos de contacto</strong>: dirección de correo electrónico (al suscribirse al briefing diario o al formulario de contacto) y, opcionalmente, nombre.</li>
          <li><strong>Datos técnicos de navegación</strong>: dirección IP <em>codificada irreversiblemente</em> (hash), país y ciudad aproximadas derivadas de la IP, página visitada, sitio de referencia, fecha y hora de la visita, y tipo de navegador/dispositivo.</li>
        </ul>
        <p>
          <strong>No se recaban datos sensibles</strong> conforme al artículo 3, fracción VI, de la LFPDPPP.
          La dirección IP completa <strong>no se almacena</strong>; sólo conservamos un hash unidireccional para
          conteo de visitantes únicos sin posibilidad de identificación reversible.
        </p>

        <h2 className="font-serif-display text-2xl mt-8 mb-2">3. Finalidades del tratamiento</h2>
        <p>Sus datos personales serán utilizados para las siguientes finalidades:</p>
        <p className="font-mono text-[11px] uppercase tracking-widest mt-4 mb-1 text-rojo">Finalidades primarias (necesarias)</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Enviarle el briefing diario de POLÍTICA REAL al correo proporcionado.</li>
          <li>Atender solicitudes que usted nos envíe por correo de contacto.</li>
          <li>Generar estadísticas agregadas y anónimas sobre el uso del sitio (audiencia total, países, páginas más leídas) con fines editoriales y de mejora del servicio.</li>
        </ul>
        <p className="font-mono text-[11px] uppercase tracking-widest mt-4 mb-1 text-sub">Finalidades secundarias</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Eventualmente comunicarle ediciones especiales o información sobre nuevos productos editoriales del propio POLÍTICA REAL.</li>
        </ul>
        <p className="mt-3">
          Si usted no desea que sus datos sean tratados para las finalidades secundarias,
          puede manifestarlo en cualquier momento utilizando el enlace de cancelación que aparece
          al pie de cada correo, o escribiéndonos a {" "}
          <a className="underline" href="mailto:privacidad@politicareal.com">privacidad@politicareal.com</a>.
        </p>

        <h2 className="font-serif-display text-2xl mt-8 mb-2">4. Transferencias de datos</h2>
        <p>
          POLÍTICA REAL <strong>no vende, cede ni renta sus datos personales a terceros con fines comerciales</strong>.
          Para la operación técnica del sitio y del envío de correo electrónico, el Responsable utiliza
          los siguientes proveedores que actúan como <em>encargados</em> bajo contrato con cláusulas de confidencialidad:
        </p>
        <ul className="list-disc pl-6 my-3 space-y-1">
          <li><strong>Resend Inc.</strong> (Estados Unidos) — entrega del correo del briefing diario.</li>
          <li><strong>Emergent / Cloudflare / MongoDB Atlas</strong> — hospedaje y base de datos del sitio.</li>
          <li><strong>ip-api.com</strong> — derivación geográfica aproximada (país, ciudad) a partir de IP, sin almacenar la IP en sí.</li>
        </ul>
        <p>
          Estas transferencias son las indispensables para prestar el servicio que usted solicitó.
          De conformidad con el artículo 37 de la LFPDPPP, no se requiere su consentimiento expreso para ellas.
        </p>

        <h2 className="font-serif-display text-2xl mt-8 mb-2">5. Derechos ARCO</h2>
        <p>
          En cualquier momento, usted puede ejercer los derechos de <strong>Acceso</strong>,
          <strong> Rectificación</strong>, <strong>Cancelación</strong> u <strong>Oposición</strong> (Derechos ARCO),
          así como revocar el consentimiento que haya otorgado, conforme a los artículos 22 a 28
          de la LFPDPPP. Para ello, envíe un correo a {" "}
          <a className="underline" href="mailto:privacidad@politicareal.com">privacidad@politicareal.com</a>{" "}
          indicando:
        </p>
        <ul className="list-disc pl-6 my-3 space-y-1">
          <li>Su nombre y dirección de correo electrónico para recibir respuesta.</li>
          <li>Documento que acredite su identidad (copia simple de identificación oficial).</li>
          <li>Descripción clara y precisa del derecho que desea ejercer.</li>
        </ul>
        <p>
          El Responsable responderá su solicitud en un plazo máximo de 20 días hábiles, conforme a lo dispuesto
          por el artículo 32 de la LFPDPPP, y en caso de proceder, hará efectiva la solicitud
          dentro de los 15 días hábiles siguientes a la respuesta.
        </p>
        <p>
          La cancelación de su suscripción al briefing diario también puede realizarse de forma inmediata
          dando clic en el enlace <strong>"Cancelar suscripción"</strong> incluido al pie de cada correo enviado.
        </p>

        <h2 className="font-serif-display text-2xl mt-8 mb-2">6. Conservación de los datos</h2>
        <p>
          Sus datos serán conservados únicamente por el tiempo en que usted permanezca suscrito al briefing.
          Los datos técnicos de navegación se conservan por un máximo de <strong>12 meses</strong> con fines
          estadísticos y, posteriormente, son eliminados o anonimizados de forma irreversible.
        </p>

        <h2 className="font-serif-display text-2xl mt-8 mb-2">7. Cookies y tecnologías similares</h2>
        <p>
          POLÍTICA REAL <strong>no utiliza cookies de seguimiento publicitario ni de terceros</strong>.
          El sitio utiliza únicamente almacenamiento local del navegador (<code>localStorage</code>, <code>sessionStorage</code>)
          para recordar sus preferencias de visualización (por ejemplo, si cerró la barra de suscripción) y para
          mejorar el rendimiento. Estos datos permanecen sólo en su dispositivo y no se transmiten a nuestros servidores.
        </p>

        <h2 className="font-serif-display text-2xl mt-8 mb-2">8. Cambios al Aviso de Privacidad</h2>
        <p>
          El presente Aviso puede actualizarse para reflejar cambios en nuestras prácticas de información,
          en la legislación aplicable, o en nuestro servicio. La versión vigente siempre estará disponible
          en esta misma página, con su fecha de última actualización al inicio del documento. Le recomendamos
          revisarlo periódicamente.
        </p>

        <h2 className="font-serif-display text-2xl mt-8 mb-2">9. Autoridad reguladora</h2>
        <p>
          Si usted considera que su derecho a la protección de datos personales ha sido vulnerado, puede acudir
          al <strong>Instituto Nacional de Transparencia, Acceso a la Información y Protección de Datos
          Personales (INAI)</strong>: {" "}
          <a className="underline" href="https://www.inai.org.mx" target="_blank" rel="noopener noreferrer">
            inai.org.mx
          </a>
          .
        </p>

        <hr className="my-10 border-rule" />
        <p className="text-sm text-sub italic">
          Al suscribirse al briefing o utilizar este sitio, usted reconoce haber leído y comprendido
          el presente Aviso de Privacidad y otorga su consentimiento para el tratamiento de sus datos
          conforme a las finalidades primarias aquí descritas.
        </p>
      </div>
    </div>
  );
}
